import React, { useContext, useEffect, useState } from "react";
import {
  CatchMessage,
  JSONtoformdata,
  tokenisValid,
} from "../../Shared/Methods";
import { useDispatch, useSelector } from "react-redux";
import { handleloading } from "../../Store/Redux/Reducers/Dashboardreducers";
import { UserListDeviceMapping } from "../../Services/ApiServices";
import { HandleSessionModal } from "../../Store/Redux/Reducers/Authreducers";
import { toast } from "react-toastify";
import { devicecontext } from "../../Screens/HomeScreen/ViewDevice";
import Commonpagination from "../Tables/CommonPagination";
import classes from "./Demodevice.module.css";
import { Col, Row } from "antd";
import CommonNodataFound from "../CommonNodataFound";
import Commontooltip from "../CommonTooltip/Commontooltip";

function DeviceUserDetails() {
  const { LoginData } = useSelector((state: any) => state.Auth);
  const contextdata = useContext(devicecontext);
  const { item } = contextdata || {};
  const [userDevice, setUserDevice] = useState<any>({});
  const [pageSize, setpageSize] = useState(10);
  const [pageind, setPageInd] = useState(0);
  const [showModal, setShowModal] = useState<any>({
    isView: false,
    item: "",
    create: "",
  });
  const [showConfirmModal, setShowConfirmModal] = useState<any>({
    isView: false,
    item: "",
  });
  const [changePassword, setChangePassword] = useState({
    isView: false,
    item: "",
  });
  const dispatch = useDispatch();

  const { total_count, page, size } = userDevice;

  useEffect(() => {
    if (LoginData !== null) {
      handleListUserDevice();
    }
  }, [LoginData]);

  const handleListUserDevice = (page = 1, size = 10) => {
    dispatch(handleloading(true));

    let finalObj = {
      token: LoginData?.token,
      deviceId: item?.deviceId,
    };

    UserListDeviceMapping(page, size, JSONtoformdata(finalObj))
      .then(async (res) => {
        if (res.data.status === 1) {
          setUserDevice(res.data.data);

          setPageInd(page > 1 ? page - 1 : 0);
        } else if (res.data.status === -1) {
          const istokenValid = await tokenisValid(LoginData?.token);
          if (istokenValid) {
            toast.error(res.data.msg);
          } else {
            dispatch(HandleSessionModal(true));
          }
        } else {
          toast.error(res.data.msg);
        }
      })
      .catch((err) => CatchMessage(err))
      .finally(() => {
        dispatch(handleloading(false));
      });
  };

  const Changesize = (current: number, size: number) => {
    // setPageInd(0); //change into 0 from 1
    setpageSize(size);
    handleListUserDevice(1, size);
  };

  return (
    <>
      <div className="primarycard h-100">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "12px",
          }}
        >
          <p style={{ margin: "0" }} className="device_heading_style">
            User
          </p>
        </div>
        {/* <Newcommontable
          Children={
            <UserTable
              Data={userDevice}
              pageSize={pageSize}
              pageind={pageind}
              GetList={handleListUserDevice}
              setpageSize={setpageSize}
              setPageInd={setPageInd}
              OBJHead={["S.No", "Name", "Access Type", "Mobile"]}
              OBJKeys={["name", "access_type", "phone"]}
              setShowModal={setShowModal}
              setShowConfirmModal={setShowConfirmModal}
              setChangePassword={setChangePassword}
              setUserDevice={setUserDevice}
              userDevice={userDevice}
            />
          }
          style={{
            overflow: "auto",
            maxHeight: "200px",
            margin: "5px 0 47px 0",
          }}
        /> */}

        <div
          style={
            userDevice?.items?.length <= 0
              ? {
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }
              : {
                  overflowX: "auto",
                  maxHeight: "300px",
                  marginBottom: "50px",
                }
          }
          // className={userDevice?.items?.length > 0 ? "h-100" : "scroll_inner"}
          className={"scroll_inner"}
        >
          <Row gutter={[16, 16]} className="m-0">
            {userDevice?.items?.length > 0 ? (
              userDevice?.items?.map((ele: any, ind: number) => (
                <Col key={ind} xxl={4} xl={6} lg={6} sm={12} xs={24}>
                  <div className={classes.device_alert_settings_container}>
                    <div
                      className={classes.device_alert_settings_container_header}
                    >
                      {/* <p style={{ fontWeight: 600 }}>{ele?.name}</p> */}
                      <Commontooltip
                        children={
                          <p
                            style={{ fontWeight: 600 }}
                            className="cards_name_heading"
                          >
                            {ele?.name}
                          </p>
                        }
                        msg={ele?.name}
                        placement="topLeft"
                      />
                    </div>
                    <div
                      style={{
                        padding: "12px",
                        display: "flex",
                        flexDirection: "column",
                        gap: "5px",
                      }}
                      className={classes.keysstyle}
                    >
                      {/* <div>
                        <p>
                          Name : <span>{ele?.name}</span>
                        </p>
                      </div> */}
                      <div>
                        <p>
                          Access Type :{" "}
                          <span>
                            {ele?.access_type === 1 ? "Edit" : "View"}
                          </span>
                        </p>
                      </div>
                      <div>
                        <p>
                          Mobile : <span>{ele?.phone}</span>
                        </p>
                      </div>
                    </div>
                  </div>
                </Col>
              ))
            ) : (
              <CommonNodataFound />
            )}
          </Row>
        </div>
        <div>
          <Commonpagination
            onShowSizeChange={Changesize} ///call when page size click
            total={total_count}
            current={page}
            pageSize={size}
            onChange={(e, size) => {
              ///call when page number click
              if (size === pageSize) {
                handleListUserDevice(e, size);
              }
            }}
            style={{ position: "absolute", bottom: 0, marginBottom: "15px" }}
          />
        </div>
      </div>
    </>
  );
}

export default DeviceUserDetails;
